import { inject } from '@angular/core';
import { CanDeactivateFn, RouterStateSnapshot, ActivatedRouteSnapshot } from '@angular/router';

import { AppWizardService } from '../services/app-wizard.service';
import { WizardComponent } from '../components/wizard/wizard.component';

export const wizardExitGuard: CanDeactivateFn<WizardComponent> = async (
	_component: WizardComponent,
	_currentRoute: ActivatedRouteSnapshot,
	_currentState: RouterStateSnapshot,
	nextState: RouterStateSnapshot
) => {
	const appWizardService = inject(AppWizardService);
	if (
		// wizard -> template
		nextState.url.includes('template')
		// wizard -> product
		|| nextState.url.includes('product')
		// wizard -> product
		|| nextState.url.includes('filter')
		// not in wizard session
		|| !appWizardService.getState().isValid
		// in wizard session and go back to wizard page
		|| (
			appWizardService.getState().isValid
			&& nextState.url.includes('wizard')
		)
	) {
		return true;
	}
	return appWizardService.actionExitWizard();
};
